import { useMutation} from "@tanstack/react-query";
import http from "../http";

const getDocument = async (documentId: string) => {
  try{
    const queryParams = new URLSearchParams();
    queryParams.append('receiptNumber', documentId);
    const response = await http.get<string>(
      `docs/ecomplaintreceiptservice/previewDocument?${queryParams.toString()}`,
      {
        responseType: "blob",
      }
    );
    return response;
  }catch(err: any){
    return null;
  }

};

const useDocument = (
    documentId:string
) =>
  useMutation<any>({
    mutationKey: ["document", documentId],
    mutationFn: ()=>getDocument(documentId),
    networkMode: "offlineFirst",
  });

export default useDocument;
